import {
  target_date, materialCode, price_per_unit, total_price, bom_item,
} from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    bom_item: {
      ...bom_item,
      name: 'Sub Job',
    },
    materialCode,
    material: {
      name: 'ชิ้นส่วน',
      width: '1fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.material?.name,
    },
    materialBrand: {
      name: 'Brand',
      width: '10rem',
      filter: (val: string, row: any) => row.item.material?.brand,
    },
    purchaseRequest: {
      name: 'รหัส PR',
      width: '5rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.purchase_request?.code,
    },
    amount: {
      name: 'จำนวนที่สั่ง / รับแล้ว',
      width: '8rem',
      class: 'text-center',
      filter: (val: string, row: any) => `${parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} / ${parseFloat(row.item.filled_amount || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`,
    },
    purchase_unit: {
      name: 'หน่วยสั่งซื้อ',
      width: '5rem',
      class: 'text-left',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : '-',
    },
    price_per_unit,
    total_price,
    target_date,
  },
};
